import React, { useEffect, useState } from 'react';
import { Slider, Button, Tooltip, DatePicker, Toast } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import { MdInfoOutline } from 'react-icons/md';
import { isEmpty } from 'lodash';
import moment, { Moment } from 'moment';

export type MapStateType = {
	params: any;
};

export type DispatchPropsType = {
	onClose: () => void;
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => void;
    onLoad: () => void;
    onBulkLoad: (bulkid: string) => void;
};

const EditExpiryModal: React.FC<MapStateType & DispatchPropsType> = ({
	onClose,
    onSave,
    onLoad,
    onBulkLoad,
	params,
}) => {
	const { t } = useTranslation();
	const { NumberofUrl, UrlsTitle, bulk_id, callback } = params?.extraParam;
	const [stringifyTitle, setstringifyTitle] = useState<string>('');
    const [urlIds,setUrlsIds] = useState<Array<string>>([]);
	const [selecteddate, setSelectedDate] = useState<Moment | null>(null);

	useEffect(() => {
		if (!isEmpty(UrlsTitle)) {
			processNformatTitle();
		}
	}, [UrlsTitle]);

	const processNformatTitle = () => {
		//let titleString = [];
        let urlIds = [];
		for (let [key, value] of UrlsTitle) {
			//titleString.push(key.split('_')[1]);
			if(value){
				urlIds.push(key.split('_')[0]);
			}
		}
		//setstringifyTitle(titleString.toString());
        setUrlsIds(urlIds);
	};

	const renderFooter = () => {
		return (
			<div className={Styles.editExpiryUrlFooterPos}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={handleSave}>
					{t('mainSave')}
				</Button>
			</div>
		);
	};

    const handleSaveCallback = (response: any, flag: boolean) => {
        if (flag) {
            Toast(`${t('urlExpiryUpdated')}`, "success");
            if(bulk_id){
                onBulkLoad(bulk_id)
            }else{
                onLoad();
            }
            onClose();
			callback(false);
        } else {
            Toast(response?.data?.message, "error")
        }
    }

    const handleSave = () => {
        const postRequestBody = {
            ids: urlIds,
            expiry: moment(selecteddate).format('YYYY-MM-DD HH:mm:ss'),
        }
        onSave(postRequestBody, handleSaveCallback)
    }

	const renderFormBody = () => {
		return (
			<div className={Styles.formBody}>
				<div className={Styles.selectedUrl}>
					<span>{t('editExpirySelectedUrlNo')}</span>
					<span className={Styles.countContainer}>
						{' '}
						{NumberofUrl}{' '}
						{/* <Tooltip
							title={
								!isEmpty(stringifyTitle) ? stringifyTitle : '-'
							}
							trigger={'hover'}
							placement="bottomLeft"
							overlayInnerStyle={{
								maxWidth: '324px',
								maxHeight: '148px',
								overflow: 'scroll',
							}}
						>
							<MdInfoOutline fontSize={'large'} />
						</Tooltip> */}
					</span>
				</div>
				<div className={Styles.datePickerWrapper}>
					<div>{t('urlExpiryHeading')}</div>
					<DatePicker
						style={{ width: '100%' }}
						value={selecteddate}
						onChange={(date: any) => setSelectedDate(date)}
						showToday={false}
						disabledDate={(date) => {
							return (
								date &&
								!(
									date >
										moment().add(1, 'day').startOf('day') &&
									date < moment().add(1, 'year').endOf('day')
								)
							);
						}}
					/>
					<div className={Styles.desc}>{t('urlExpiryDescption')}</div>
				</div>
			</div>
		);
	};

	return (
		<>
			<Slider
				onClose={onClose}
				visibility={true}
				footer={renderFooter()}
				title={t('editExpiryDateModal')}
			>
				<div className={Styles.editExpiryUrlModal}>
					{renderFormBody()}
				</div>
			</Slider>
		</>
	);
};

export default EditExpiryModal;
